module.exports = __webpack_public_path__ + "static/media/TOEFL_logo.19ee2c37.png";